import api from '../../utils/api';
import utilities from '../../utils/utilities';

// initial state
const state = {
    id: null,
    name: null,
    sex: 1,
    sexes: [
        { id: 1, name: 'SEX__MALE' },
        { id: 2, name: 'SEX__FEMALE' }
    ],
    visible: false,
    errors: {}
};

// mutations
const mutations = {
    errors(state, errors) {
        state.errors = errors;
    },
    show(state, data) {
        state.id = data.id;
        state.name = data.name;
        state.sex = data.sex;
        state.visible = true;
    },
    close(state) {
        state.visible = false;
        state.id = null;
        state.name = null;
        state.sex = 1;
        state.errors = {};
    },
    //Setters
    id(state, value) {
        state.id = value;
    },
    name(state, value) {
        state.name = value;
    },
    sex(state, value) {
        state.sex = value;
    }
};

// actions
const actions = {
    open(store, id) {
        store.commit('id', id);
        if (id != null) {
            api.get(`/api/list/${id}`).then(function (response) {
                if (store.state.id === id) {
                    store.commit('show', response.body);
                }
            });
        } else {
            store.commit('show',
                {
                    id: null,
                    name: null,
                    sex: 1
                });
        }
    },
    close(store) {
        store.commit('close');
    },
    save(store, target) {
        const model = {
            id: store.state.id,
            name: store.state.name,
            sex: store.state.sex
        };
        utilities.disableButton(target);

        if (store.state.id) {
            api.put(`/api/list/${store.state.id}`,
                model,
                'listItem/errors').then(function() {
                    utilities.enableButton(target);
                    store.dispatch('list/getItems', null, { root: true });
                    store.commit('close');
                },
                function() {
                    utilities.enableButton(target);
                });
        } else {
            api.post('/api/list/',
                model,
                'listItem/errors').then(function () {
                    utilities.enableButton(target);
                    store.dispatch('list/getItems', null, { root: true });
                    store.commit('close');
                },
                function () {
                    utilities.enableButton(target);
                });
        }
    },
    confirmDeleteItem(store) {
        store.dispatch('confirmation/open',
            {
                title: 'LIST__DELETE_ITEM_PROMPT',
                handlerAction: 'listItem/deleteItem',
                handlerActionParams: null
            },
            { root: true });
    },
    deleteItem(store) {
        api.delete(`/api/list/${store.state.id}`).then(function () {
            store.dispatch('list/getItems', null, { root: true });
            store.commit('close');
        },
            function () {
            });
    },
    //Setters
    setName(store, value) {
        store.commit('name', value);
    },
    setSex(store, value) {
        store.commit('sex', +value);
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/listItem.js